export default __webpack_public_path__ + "static/media/Maps.0eec4a43.png";